﻿import m from 'mithril';
import Requester from '../../shared/request';
import Gateway from '../../shared/app_settings';
import Toasts from '../../shared/toasts';
import Auth from '../../shared/auth';
import ModalManager from '../../shared/modal';
import OrgFileService from '../../shared/storage/org_file_service';
import Modal_Organisation_New from './modal_organisation_new';
import i18n from "../../shared/i18n/i18n";
import RouterService from '../../shared/services/router.service';

let loading = false;
let orgs = [];

function reloadOrgs() {
    loading = true;
    setTimeout(function () { loadOrgs(); }, 500);
}

function loadOrgs() {
    loading = true;
    Requester.get(Gateway.admin + "account/organisations")
        .then(function (result) {
            orgs = result;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            loading = false;
        });
}

function visitOrg(org) {
    loading = true;
    Requester.get(Gateway.identity + "req-tr?target=" + org.id)
        .then(function (result) {
            window.location = RouterService.getOrganisationTransitionUrl(org.hostname, result, RouterService.getAdminUrl());
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            loading = false;
        });
}

function createOrg() {
    ModalManager.open(i18n.t("create_organisation"), [], Modal_Organisation_New, { callback: reloadOrgs });
}

const Page_Organisations = {
    oninit: function () {
        loadOrgs();
        let currentPage = "organisations";
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section", [
                        m("h1", i18n.t("organisations"))
                    ]),
                    m(".toolbar-section", [
                        Auth.validateRights(["org_create"], m("button.with-icon btn-cta", {onclick: createOrg}, [m("i.icon-plus"), i18n.t("create_organisation")]))
                    ])
                ])
            ]),
            !loading ? [
                orgs ? [
                    orgs.length > 0 ? [
                        m(".org-box-list", orgs.map(function (org) {
                            return [
                                m(".org-box",
                                    m(".flex-column", [
                                        m(".img",
                                            org.logoName ? m("img", {src: OrgFileService.getLogoPath(org.id, org.logoName)}) : ""
                                        ),
                                        m(".padding flex-column flex-auto full-height", [
                                            m(".flex-auto full-height", [
                                                m(".text-bold", org.name)
                                            ]),
                                            m(".form-buttons", [
                                                Auth.validateRights(["org_view"], m("button.btn-text", {
                                                    onclick: function () {
                                                        RouterService.navigateToOrganisation(org.id);
                                                    }
                                                }, i18n.t("settings"))),
                                                Auth.validateRights(["org_view"], m("button", {
                                                    onclick: function () {
                                                        visitOrg(org);
                                                    }
                                                }, "Access"))
                                            ])
                                        ])
                                    ])
                                )
                            ];
                        }))
                    ] : m(".text-gray content-box", "No Organisations")
                ] : m(".text-gray content-box", "Unable to load organisations")
            ] : m(".text-gray content-box", ["Loading", m(".loading-dots")])
        ];
    }
};

export default Page_Organisations;
